export enum ErknmReasonsDocumentTypesEnum {
  VP_I = 'VP_I',
  VP_II = 'VP_II',
  VP_IV = 'VP_IV',
  VP_VIII = 'VP_VIII',
}
